// DaisyUI 5 dropped form-control, so the explicit flex column is what gives flex-1 below a
// context to grow into, keeping the control beneath its title in line with the other fields.
export const TITLED_COLUMN = 'flex flex-col self-stretch';
export const BENEATH_TITLE = 'flex flex-1 items-center';
